import React from 'react';
import { BubbleCheckbox, BubbleFormGroup } from '@go-client/components/BubbleUI';
import { CallToActions } from '@go-client/components/BasicForms/CallToActions';
import { CallToActionsInstance, DailyProgramCta } from '@go-shared/types/dailyProgram';

interface CallToActionsManagementProps {
  sourceCtas: CallToActionsInstance;
  parentCtas: DailyProgramCta[];
  onUpdate: (cta: CallToActionsInstance) => void;
}

export const CallToActionsManagement: React.FC<CallToActionsManagementProps> = (
  props: CallToActionsManagementProps
) => {
  const { sourceCtas, parentCtas, onUpdate } = props;
  const callToActions = sourceCtas.syncWithTemplate ? parentCtas : sourceCtas.values;

  const handleCtaUpdates = (formCtas: DailyProgramCta[]) => {
    const syncWithTemplate = JSON.stringify(formCtas) === JSON.stringify(parentCtas)
    onUpdate({ syncWithTemplate, values: formCtas });
  };
  return (
    <fieldset>
      <BubbleFormGroup className="mb-5" label="Call to Actions">
        <BubbleCheckbox
          className="mb-3"
          checked={sourceCtas?.syncWithTemplate ?? true}
          onValue={chk => {
            onUpdate({
              syncWithTemplate: chk,
              values: sourceCtas.values,
            });
          }}
          label="Default to Library"
        />

        <CallToActions callToActions={callToActions} onUpdate={handleCtaUpdates} />
      </BubbleFormGroup>
    </fieldset >
  );
};
